import { IconeCheck } from '@/components/atoms/Icones/IconeCheck';
import * as S from './styles';
import { useTheme } from 'styled-components';
import { IconeFechar } from '@/components/atoms/Icones/IconeFechar';
import Text from '@/components/atoms/Text';

interface IndicadorValidacaoCampoProps {
  $condicao: boolean;
  $text: string;
}

export default function IndicadorValidacaoCampo(
  props: IndicadorValidacaoCampoProps,
) {
  const { $condicao, $text } = props;
  const theme = useTheme();

  return (
    <S.Container style={$condicao ? {} : { opacity: 0.45 }}>
      {$condicao ? (
        <IconeCheck
          size={theme.typography.font.size[4]}
          color={theme.colors.default.white}
        />
      ) : (
        <IconeFechar
          size={theme.typography.font.size[4]}
          color={theme.colors.default.white}
        />
      )}
      <Text
        $size={1}
        $color={'neutral'}
        $weight="bold"
        $align="left"
        $highContrast={true}
        $text={$text}
        style={{
          fontSize: 'clamp(10px, 2.5vw, 12px)',
          lineHeight: '1.4',
        }}
      />
    </S.Container>
  );
}
